(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/product-mapping.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/product-mapping.js');

'use strict';

const CONSTANTS = {
  LYCKOPLATSEN: 'LYCKOPLATSEN',
  LYCKOPLATSEN_PRIMARY: 'LYCKOPLATSEN_PRIMARY',
  LYCKOPLATSEN_SECONDARY: 'LYCKOPLATSEN_SECONDARY'
};
const lyckoplatsen = {
  id: 'LYCKOPLATSEN',
  name: 'Lyckoplatsen',
  wagersId: 'GEO1',
  drawId: 'lyckoplatsen',
  drawType: 'lyckoplatsen',
  branding: 'lyckoplatsen',
  isProductFamily: true
};
const lyckoplatsenPrimary = {
  id: 'LYCKOPLATSEN',
  itsId: 'LYCKOPLATSEN_PRIMARY',
  name: 'Lyckoplatsen',
  numericId: 48,
  wagersId: 'GEO1',
  drawId: 'lyckoplatsenprimary',
  drawType: 'lyckoplatsen primary',
  branding: 'lyckoplatsen'
};
const lyckoplatsenSecondary = {
  id: 'LYCKOPLATSEN',
  itsId: 'LYCKOPLATSEN_SECONDARY',
  name: 'Lyckoplatsen',
  numericId: 49,
  wagersId: 'GEO2',
  drawId: 'lyckoplatsensecondary',
  drawType: 'lyckoplatsen secondary',
  branding: 'lyckoplatsen'
};
const products = {
  48: lyckoplatsenPrimary,
  lyckoplatsenprimary: lyckoplatsenPrimary,
  lyckoplatsen_primary: lyckoplatsenPrimary,
  'lyckoplatsen primary': lyckoplatsenPrimary,
  geo1: lyckoplatsenPrimary,
  49: lyckoplatsenSecondary,
  lyckoplatsensecondary: lyckoplatsenSecondary,
  lyckoplatsen_secondary: lyckoplatsenSecondary,
  'lyckoplatsen secondary': lyckoplatsenSecondary,
  geo2: lyckoplatsenSecondary,
  lyckoplatsen,
  GEO: lyckoplatsen
};
function getProduct(product) {
  if (typeof product === 'string') {
    product = product.toLowerCase();
  }
  return products[product];
}
function getProductId(product) {
  product = getProduct(product);
  if (product) {
    return product.id;
  }
  return 0;
}
function getProductItsId(product) {
  product = getProduct(product);
  if (product && product.itsId) {
    return product.itsId;
  }
  return '';
}
function getProductName(product) {
  product = getProduct(product);
  if (product) {
    return product.name;
  }
  return '';
}
function getProductNumericId(product) {
  product = getProduct(product);
  if (product) {
    return product.numericId;
  }
  return 0;
}
function getProductWagersId(product) {
  product = getProduct(product);
  if (product) {
    return product.wagersId;
  }
  return '';
}
function getProductDrawId(product) {
  product = getProduct(product);
  if (product) {
    return product.drawId;
  }
  return '';
}
function getProductDrawType(product) {
  product = getProduct(product);
  if (product) {
    return product.drawType;
  }
  return '';
}
function getBrandingClass(product) {
  product = getProduct(product);
  if (product) {
    return product.branding;
  }
  return '';
}
function isProductFamily(product) {
  var _product$isProductFam, _product;
  product = getProduct(product);
  return (_product$isProductFam = (_product = product) === null || _product === void 0 ? void 0 : _product.isProductFamily) !== null && _product$isProductFam !== void 0 ? _product$isProductFam : false;
}
function isLyckoplatsenPrimary(product) {
  return Boolean(getProductItsId(product) === CONSTANTS.LYCKOPLATSEN_PRIMARY);
}
function isLyckoplatsenSecondary(product) {
  return Boolean(getProductItsId(product) === CONSTANTS.LYCKOPLATSEN_SECONDARY);
}
function isSameProduct(product1, product2) {
  const n1 = getProductNumericId(product1);
  const n2 = getProductNumericId(product2);
  if (n1 && n2) {
    return n1 === n2;
  }
  const p1 = getProductId(product1);
  const p2 = getProductId(product2);
  if (p1 && p2) {
    return p1 === p2;
  }
  return false;
}
const productMapping = {
  products,
  CONSTANTS,
  getProduct,
  getProductId,
  getProductItsId,
  getProductName,
  getProductNumericId,
  getProductWagersId,
  getProductDrawId,
  getProductDrawType,
  getBrandingClass,
  isProductFamily,
  isLyckoplatsenPrimary,
  isLyckoplatsenSecondary,
  isSameProduct
};
if (svs.isServer) {
  module.exports = productMapping;
} else {
  setGlobal('svs.lyckoplatsen.components.shared_constants', {
    productMapping
  });
}

 })(window);